import React, { useState, useEffect, useRef } from "react";
import Data from "../App";
import CompTitleRow from "./CompTitleRow";
import CompStatesView from "./CompStatesView";
import CompTemplateView from "./CompTemplateView";
import UiBindingView from "./UiBindingView";
import UiBindingPreview from "./UiBindingPreview";
import UiBindingEditView from "./UiBindingEditView";
import UiViewComposition from "./UiViewComposition";
import SignalGroup from "./SignalGroup";
import Stream from "./Stream";
import StreamGroup from "./StreamGroup";
import ScreenPart from "./ScreenPart";
import State from "./State";
import {
  map,
  distinctUntilChanged,
  switchMap,
  first,
  filter,
  tap
} from "rxjs/operators";
import { of } from "rxjs";
import { getSuperType, getStateTrees } from "./TypeHelper";
import { Primitives } from "../primitives";
import { List, is } from "immutable";

function CompView(props) {
  const [spec, setSpec] = useState(null);
  const [editing, setEditing] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [template, setTemplate] = useState(null);
  const [stateTrees, setStateTrees] = useState(null);
  const [superType, setSuperType] = useState(null);
  const [editedSpec, setEditedSpec] = useState(null);

  useEffect(() => {
    const specObs = Data.getInstance()
      .getSpecs()
      .pipe(
        map(specs => specs.get(props.compId)),
        distinctUntilChanged()
      );
    const specSub = specObs.subscribe(spec => {
      console.log("subscr loaded " + spec);
      setSpec(spec);
      setEditedSpec(spec);
    });
    const tempSub = specObs
      .pipe(
        first(),
        map(spec => spec.get("type")),
        switchMap(typeName =>
          Data.getInstance()
            .getCompTemplates()
            .pipe(
              map(temps => [temps.get(typeName), getSuperType(typeName, temps)])
            )
        )
      )
      .subscribe(arr => {
        setTemplate(arr[0]);
        setSuperType(arr[1]);
      });
    const stateSub = specObs
      .pipe(
        map(spec => spec.get("states")),
        filter(states => states),
        switchMap(states =>
          Data.getInstance()
            .getSpecs()
            .pipe(map(specs => getStateTrees(specs, states)))
            .pipe(distinctUntilChanged((listOld, list) => is(listOld, list)))
        )
      )
      .subscribe(stateTrees => {
        console.log("subscr stateTrees " + JSON.stringify(stateTrees));
        setStateTrees(stateTrees);
      });
    return () => {
      specSub.unsubscribe();
      tempSub.unsubscribe();
      stateSub.unsubscribe();
    };
  }, []);

  function handleExpandClick() {
    console.log("handleExpandClick");
    if (!editing) setExpanded(!expanded);
  }

  function handleEditClick() {
    console.log("handleEditClick ");
    setEditing(true);
    setExpanded(true);
  }

  function handleCancelClick() {
    console.log("handleCancelClick ");
    setEditing(false);
    setExpanded(false);
    setEditedSpec(spec);
  }

  function handleSaveClick() {
    console.log("handleSave ");
    Data.getInstance().changeSpec(editedSpec);
    setEditing(false);
    //setExpanded(false);
  }

  function handleDeleteClick() {
    console.log("handleDeleteClick ");
    Data.getInstance().removeSpec(spec.get("id"));
    if (props.onDelete) props.onDelete();
  }

  function setChangedSpec(spec) {
    setEditedSpec(spec);
  }
  if (!spec) return "";
  let states = "";
  if (stateTrees) states = <CompStatesView states={stateTrees} />;
  let view;
  if (spec.get("type") === "ui-binding") {
    if (editing)
      view = (
        <UiBindingEditView binding={editedSpec} onChange={setChangedSpec} />
      );
    else if (expanded) view = <UiBindingView binding={editedSpec} />;
    else view = <UiBindingPreview binding={editedSpec} />;
  } else if (spec.get("type") === "view_composition") {
    view = (
      <UiViewComposition
        spec={editedSpec}
        expanded={expanded}
        editing={editing}
        onChange={setChangedSpec}
      />
    );
  } else if (spec.get("type") === "screenPart") {
    view = (
      <ScreenPart
        spec={editedSpec}
        editing={editing}
        onChange={setChangedSpec}
      />
    );
  } else if (spec.get("type") === "streamGroup") {
    view = (
      <StreamGroup
        spec={editedSpec}
        editing={editing}
        onChange={setChangedSpec}
      />
    );
  } else if (spec.get("type") === "stream") {
    view = (
      <Stream
        stream={editedSpec}
        editing={editing}
        expanded={expanded}
        onChange={setChangedSpec}
      />
    );
  } else if (spec.get("type") === "signalGroup") {
    view = (
      <SignalGroup
        signalGroup={editedSpec}
        editing={editing}
        onChange={setChangedSpec}
      />
    );
  } else if (spec.get("type") === "state") {
    view = (
      <State
        state={editedSpec}
        expanded={expanded}
        editing={editing}
        onChange={setChangedSpec}
      />
    );
  } else if (template)
    view = (
      <CompTemplateView
        spec={editedSpec}
        template={template}
        superType={superType}
        editing={editing}
        expanded={expanded}
        states={stateTrees ? stateTrees : props.parentStates}
        onChange={setChangedSpec}
      />
    );

  let nameClass = "Comp";
  if (expanded) nameClass = "CompExpanded";
  else if (superType === "view") nameClass = "View";
  return (
    <div
      className={nameClass}
      onClick={e => {
        e.stopPropagation();
        handleExpandClick();
      }}
      style={{ paddingTop: editing || expanded ? 26 : 0 }}
    >
      {states}
      {view}
      <div className="ViewTitleRowContainer">
        <CompTitleRow
          spec={spec}
          editing={editing}
          expanded={expanded}
          edit={handleEditClick}
          cancel={handleCancelClick}
          save={handleSaveClick}
          del={handleDeleteClick}
        />
      </div>
    </div>
  );
}
export default CompView;



// WEBPACK FOOTER //
// ./src/components/CompView.js